// extracted by mini-css-extract-plugin
export default {"redDot":"styles_redDot__KnKSP"};